import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useFeatures } from '../context/FeatureContext';
import CompanySetupLayout from '../jsx/components/Onboarding/CompanySetupLayout';

export default function BillingAccessGate({ children }) {
    const { entitlements, hasLoaded, isLoading, refreshEntitlements } = useFeatures();
    const location = useLocation();
    const match = location.pathname.match(/^\/([0-9a-f-]{36})(?:\/|$)/i);
    const companyId = match?.[1];
    if (companyId && (!hasLoaded || entitlements?.companyId !== companyId)) {
        const failed = hasLoaded && !isLoading && !entitlements;
        return <CompanySetupLayout><div className="company-setup-status" role="status">
            <h1>{failed ? 'Kunde inte hämta företaget' : 'Vi förbereder ditt företag'}</h1>
            <p>{failed ? 'Försök igen för att hämta företagets prenumeration.' : 'Hämtar prenumeration och åtkomst…'}</p>
            {failed && <button className="company-setup-button" onClick={refreshEntitlements}>Försök igen</button>}
        </div></CompanySetupLayout>;
    }
    const choosingPlan = location.pathname === `/${companyId}/choose-plan`;
    const legacyCheckoutReturn = location.pathname.startsWith(`/${companyId}/settings`) && new URLSearchParams(location.search).get('payment') === 'plan_success';
    if (companyId && !choosingPlan && (legacyCheckoutReturn || entitlements?.planSelectionRequired || entitlements?.billingAccess?.code === 'BILLING_PLAN_SELECTION_REQUIRED')) {
        return <Redirect to={{ pathname: `/${companyId}/choose-plan`, search: location.search }} />;
    }
    if (hasLoaded && companyId && !choosingPlan && entitlements?.companyId === companyId &&
        entitlements?.billingAccess?.allowed === false && !location.pathname.startsWith(`/${companyId}/settings`)) {
        return <Redirect to={{ pathname: `/${companyId}/settings`, search: '?tab=subscription' }} />;
    }
    return children;
}
